import React, { useEffect, useState } from 'react';
import { Modal, Form, Button, Icon, Input, Message, MessageHeader } from 'semantic-ui-react';
import { useAuth } from "../../App";
import { ref, set } from "firebase/database";
import { db } from "../../utils/firebase"

export default function QRAliasDialog({
  open,
  onClose
}) {
  const { user } = useAuth();
  const [alias, setAlias] = useState('');
  const [loading, setLoading] = useState(false);


  useEffect(() => {
    if (!open) {
      setAlias('');
    }
  }, [open]);

  const handleSubmit = async () => {
    setLoading(true);
    saveAliasIntoDB()
    setLoading(false);
    onClose();
  };

  const saveAliasIntoDB = () => {
    set(ref(db, "users/" + user.uid + "/alias"), alias)
      .then(() => {
        console.log("QR zapísané");
        onClose();
      })
      .catch((error) => {
        console.error("Chyba pri zapisovaní:", error);
      });
  }

  const canSubmit = alias.trim().length > 3 && alias.trim().length < 9;

  const updateAlias = (e) => {
    const newAlias = e.target.value.toUpperCase();
    const validate = (value) => {
      const regex = /^[A-Z0-9]+$/;
      return regex.test(value);
    }

    if (validate(newAlias) || newAlias.length == 0) {
      setAlias(newAlias)
    }
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="tiny"
      closeOnDimmerClick={true}
    >
      <Modal.Header>QR alias</Modal.Header>
      <Modal.Content>
        <p>
          QR alias je skratka, pod ktorou ťa môžu všetci kontaktovať.
          Na túto skratku bude odkazovať tvoja QR nálepka.
        </p>
        <p>
          Ak si chceš dať nálepku na auto, odporúčame tvoje EČV, napr. AA123AB
          Vygenerovaný kód potom bude odkazovať na https://kontaktuj.sk/AA123AB
        </p>
        <p>Skratka musí byť jedinečná a musí mať 4-8 znakov, povolené sú len čísla a veľké písmená bez diakritiky</p>
        <Message
          color='red'
          header='POZOR'
          content='Tvoj QR alias sa nebude dať zmeniť - zvoľ si múdro.'
        />
        <Form>
          <Form.Field required>
            <label>ZADAJ SVOJ JEDINEČNÝ QR ALIAS (napr. EČV auta)</label>
            <Input
              type='text'
              iconPosition="left"
              value={alias}
              onChange={(e) => updateAlias(e)}
              disabled={loading}
              required
              icon={<Icon name="qrcode" />}
            />
          </Form.Field>

          <Button
            type="submit"
            color='yellow'
            fluid
            size="large"
            loading={loading}
            onClick={handleSubmit}
            disabled={!canSubmit}
            content="Vytvoriť"
          />

          <Button
            type="button"
            basic
            fluid
            size="large"
            disabled={loading}
            onClick={onClose}
            style={{ marginTop: 8 }}
            content="Zrušiť"
          />
        </Form>
      </Modal.Content>

      <style>{`
        @media (max-width: 480px) {
          .ui.modal > .content { padding-top: 1rem; padding-bottom: 1rem; }
          .ui.modal .ui.form .field > label { margin-bottom: .4rem; }
        }
        .ui.dimmer { background-color: rgba(0, 0, 0, 0.5);}
      `}</style>
    </Modal >
  );
}